{
  "version": 1,
  "asset_id": "0a8feed4-3383-4ffd-828d-a9575a3add6d",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/0a8feed4-3383-4ffd-828d-a9575a3add6d/destination-roofing-owner-sales-team-crystal-river-fl-1200w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/0a8feed4-3383-4ffd-828d-a9575a3add6d/destination-roofing-owner-sales-team-crystal-river-fl-1200w.webp",
  "original_filename": "destination-roofing-owner-sales-team-crystal-river-fl-1200w.webp",
  "size": 71806,
  "content_type": "image/webp",
  "created_at": "2026-07-21T15:42:45Z"
}
